export const MANAGERS = [
  { id: 1, name: 'Mario de Souza' },
  { id: 2, name: 'João da Silva' },
  { id: 3, name: 'Maria Oliveira' },
];

export const COLABORADORES = [
  {
    id: 1,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 2,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 3,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 4,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 5,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 6,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 7,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 8,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 9,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 10,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
  {
    id: 11,
    name: 'Antônio Ramos',
    cargo: 'Almoxarife',
  },
];

export const JUSTIFICATION_MAX_LENGTH = 2000;
